import { render, staticRenderFns } from "./secretKey.vue?vue&type=template&id=2aa5fb2a&"
import script from "./secretKey.vue?vue&type=script&lang=js&"
export * from "./secretKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports